// contexts/ConfigContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import API_URL from '../config';

const ConfigContext = createContext();

export const CONFIG_DEFAULTS = {
  nombreComercial: 'Imporisel',
  eslogan: 'Importaciones que mueven tu negocio',
  descripcionPublica: '',
  correoPublico: 'Imporisel@gmail.com',
  telefono: '+57 3103379628',
  whatsapp: '',
  direccion: 'Carrera 68 D # 10 A 25',
  ciudad: 'Bogotá, Colombia',
  horarioAtencion: '',
  facebook: '',
  instagram: '',
  tiktok: '',
  colorPrincipalPublica: '#000000',
  colorSecundario: '#1f2937',
  colorAcento: '#facc15',
  mostrarBlog: true,
  mostrarCatalogo: true,
  mostrarBusqueda: true,
  mostrarMetodosPago: true,
  mostrarWhatsapp: false,
  plazoCreditoPredeterminado: 0,
  diasReserva: 0,
};

export const ConfigProvider = ({ children }) => {
  // Valores por defecto (no deja la pantalla en blanco)
  const [config, setConfig] = useState(() => {
    // Intentar cargar de localStorage si existe
    const storedConfig = localStorage.getItem('appConfig');
    try {
      return storedConfig ? { ...CONFIG_DEFAULTS, ...JSON.parse(storedConfig) } : CONFIG_DEFAULTS;
    } catch {
      return CONFIG_DEFAULTS;
    }
  });

  const [loading, setLoading] = useState(false);

  const cargarConfiguracion = async () => {
    setLoading(true);
    try {
       const response = await fetch(`${API_URL}/configuracion`, { credentials: 'include' });
      if (!response.ok) throw new Error('Error al obtener configuración');
      const data = await response.json();

       const newConfig = { ...CONFIG_DEFAULTS, ...data };

      setConfig(newConfig);
      localStorage.setItem('appConfig', JSON.stringify(newConfig));
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, setConfig, cargarConfiguracion, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig debe usarse dentro de un ConfigProvider');
  }
  return context;
};
